import api from './api'

export default {
  async getAll() {
    const { data } = await api.get('/admin/roles')
    return data
  },

  async getById(id) {
    const { data } = await api.get(`/admin/roles/${id}`)
    return data
  },

  async getPermissions() {
    const { data } = await api.get('/admin/roles/permissions')
    return data
  },

  async create(roleData) {
    const { data } = await api.post('/admin/roles', roleData)
    return data
  },

  async update(id, roleData) {
    const { data } = await api.put(`/admin/roles/${id}`, roleData)
    return data
  }
}

